// Hooks
import { useState } from 'react';

// Components
import PlaybookCard from '../PlaybookCard/PlaybookCard';
import Button from '../Button/Button';
import Modal from '../Modal/Modal';

// Data utils
import getSubscribeFormData from '../../utils/data/getSubscribeFormData';
import { analyticsClient } from '../../client/analytics';

const SubscribeBlock = (props) => {
  const { title, buttons, card, playbookTitle } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const modalFormData = getSubscribeFormData();

  return (
    <>
      <div className="SubscribeBlock">
        <div className="SubscribeBlock-inner">
          <div className="SubscribeBlock-wrapper">
            <div className="SubscribeBlock-content">
              {title && <h3 className="SubscribeBlock-title">{title}</h3>}
              {buttons?.length >= 1 && (
                <div className="SubscribeBlock-buttonGroup">
                  {buttons.map((button, buttonIndex) => (
                    <Button
                      label={button.label}
                      url={button.url ? button.url : null}
                      icon={button.icon}
                      modifier={button.modifier}
                      key={`SubscribeBlock-button--${buttonIndex}`}
                      onClick={
                        button.opensModal
                          ? () => {
                              analyticsClient.track('[Website] Conversion secrets modal view', {
                                playbook: playbookTitle,
                              });
                              setModalOpen(true);
                            }
                          : null
                      }
                      target={button.target && button.url ? button.target : null}
                    />
                  ))}
                </div>
              )}
            </div>
            {card && (
              <div className="SubscribeBlock-card">
                <PlaybookCard {...card} />
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal open={modalOpen} onClose={() => setModalOpen(false)} formData={modalFormData} />
    </>
  );
};

export default SubscribeBlock;
